export default __webpack_public_path__ + "asset-symbols/ltc.png";